import dayjs from 'dayjs';

export const timeDifference = (date1, date2) => {
  let difference = date1.getTime() - date2.getTime();

  let daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  let hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  let minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  let secondsDifference = Math.floor(difference / 1000);

  return {
    days: daysDifference,
    hours: hoursDifference,
    minutes: minutesDifference,
    seconds: secondsDifference,
  };
};
export const characterCountWithoutSpaces = (data) => {
  let allString = data?.replace(/ /g, '');
  return allString?.length;
};
export const dateIsoToNormalDate = (dateIso) => {
  const date = new Date(dateIso);
  let dd = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate();
  let mm = date.getMonth() <= 8 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  return `${dd}/${mm}/${date.getFullYear()}`;
};

export const dateIsoToDate = (dateIso) => {
  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];
  const date = new Date(dateIso);
  return `${monthArray[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};

export const dateIsoToTime = (dateIso) => {
  return dayjs(dateIso).format('hh:mm A');
};

export const dummyFunction = () => {
  console.log('');
};

export const drawerOverlayCalculatedHeight = (props) => {
  const {drawerHeight} = props;
  return drawerHeight >= 175 ? {height: 175 + drawerHeight} : null;
};

export const drawerCalculatedHeight = (props) => {
  const {drawerHeight} = props;
  return drawerHeight >= 175 ? {top: drawerHeight} : null;
};

export const mobDrawerToOrignalState = (props) => {
  const {setDrawerHeight} = props;
  setDrawerHeight(140);
};

export const pullbox = (props) => {
  const {e, setDrawerHeight} = props;
  setDrawerHeight(e?.changedTouches[0]?.clientY);
};

 // Function to convert Emoji like ™, ©️, ® to text
 export const convertEmojiToText = (text) => {
  const replacements = {
    "™️": "™",
    "©️": "©",
    "®️": "®"
  };
  // if text is apart from string then return value
  if (typeof text !== 'string') return text;

  for (const [emoji, symbol] of Object.entries(replacements)) {
    text = text?.replace(new RegExp(emoji, 'g'), symbol);
  }
  return text;
}

export const parseJwt = (token) => {
  if (!token) return null;
  
  try {
    const base64Url = token.split('.')[1]; // Get the payload part
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    // Decode base64 string and parse JSON
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Invalid JWT token:', e);
    return null;
  }
}


// Parses the URL and compares the host exactly, so look-alikes such as
// https://evil.com/?https://images.contentstack.io/ are rejected.
export const isContentstackImageUrl = (url) => {
  if (typeof url !== 'string') return false;
  try {
    const {protocol, hostname} = new URL(url);
    return protocol === 'https:' && hostname === 'images.contentstack.io';
  } catch (error) {
    return false;
  }
};
